import angular from 'angular';
import uiRouter from 'angular-ui-router';
import Common from './common/common';
import Components from './components/components';
import AppComponent from './app.component';
import Services from './_services/services';
import 'normalize.css';
import AppRun from "./app.run";

angular.module('app', [
  uiRouter,
  Common,
  Components,
  Services
])
.config(($locationProvider) => {
  "ngInject";
  // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
  // #how-to-configure-your-server-to-work-with-html5mode
  $locationProvider.html5Mode(true).hashPrefix('!');
})
.run(AppRun)
.component('app', AppComponent);



// WEBPACK FOOTER //
// ./client/app/app.js